import styled from 'styled-components';
import { Box } from '@mui/material';

export const ProtectedContainer = styled(Box)`
  min-height: 100vh;
  background: #f8fafc;
`;

export const ExternalViewerContainer = styled(Box)`
  padding: 32px;
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  min-height: 100vh;
`;

export const TabContent = styled(Box)`
  padding: 24px 0;
`;

export const DetailPanel = styled(Box)`
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
`;
